import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/mcomponent/type_category_package/');

const state = {
    ...current_module.state,
    columns: [
        {text: '', value: 'drag', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'D', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'L', value: 'link', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'Name', value: 'name', sortable: false, filterable: true, divider: true, width: 200},
        {text: 'Match type', value: 'match_types', sortable: false, filterable: true, divider: true, width: 80},
        // {text: 'Match category', value: 'match_category', sortable: false, filterable: true, divider: true, width: 90},
        // {text: 'Match package', value: 'match_case_package', sortable: false, filterable: true, divider: true, width: 90},
        // {text: 'Match footprint', value: 'match_footprint', sortable: false, filterable: true, divider: true, width: 90},
        // {text: 'Match', value: 'match', sortable: true, filterable: false, divider: true,},
        {text: 'Type', value: 'article_type', sortable: false, filterable: true, divider: true, width: 80},
        {text: 'Category', value: 'category', sortable: false, filterable: true, divider: true, width: 90},
        // {text: 'Subcategory', value: 'subcategory', sortable: false, filterable: true, divider: true, width: 90},
        {text: 'Case/Packages', value: 'case_package', sortable: false, filterable: true, divider: true, width: 90},
        // {text: 'Created by', value: 'created_by_name', sortable: true, divider: true, },
        // {text: 'Created on', value: 'created_on', sortable: true, divider: true, type: 'datetime',},
        // {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true, },
        {text: 'Edited on', value: 'edited_on', sortable: false, divider: true, type: 'datetime', width: 90},
    ],
    options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['order'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        TypeCategoryPackageTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}